import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import Seo from "@/components/Seo";

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      <Seo
        title="Contact Bloomers — Consult Inquiry"
        description="Reach Linda at Linda@BloomersLKN.com or (704) 880-8969 to book an onsite yard and garden consultation across the Greater Lake Norman Region."
        path="/contact"
      />
      <section className="max-w-7xl mx-auto px-6 sm:px-10 pt-16 pb-8">
        <span className="pill-tag bg-[#219DC0]/10 text-[#219DC0]">Contact</span>
        <h1 className="mt-3 text-5xl sm:text-6xl font-black tracking-tight">
          Let&apos;s talk about your <span className="text-[#21C078]">yard</span>.
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-[#1C1C1C]/75 leading-relaxed">
          Reach out anytime — Linda reads every message and will get back to you shortly.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 sm:px-10 py-8 grid md:grid-cols-3 gap-6">
        <div className="card p-6" data-testid="contact-card-email">
          <div className="flex items-center gap-3 text-[#21C078] font-black">
            <Mail className="w-5 h-5" /> Email
          </div>
          <a href="mailto:Linda@BloomersLKN.com" className="mt-2 block text-lg font-bold text-[#1C1C1C] hover:text-[#21C078] break-all">Linda@BloomersLKN.com</a>
          <p className="mt-2 text-sm text-[#1C1C1C]/60">Preferred for detailed project briefs and photos.</p>
        </div>
        <div className="card p-6" data-testid="contact-card-phone">
          <div className="flex items-center gap-3 text-[#C0AD21] font-black">
            <Phone className="w-5 h-5" /> Phone
          </div>
          <div className="mt-2 text-lg font-bold text-[#1C1C1C]">(704) 880-8969</div>
          <p className="mt-2 text-sm text-[#1C1C1C]/60">Weekdays 8:30am – 5:00pm</p>
        </div>
        <div className="card p-6" data-testid="contact-card-area">
          <div className="flex items-center gap-3 text-[#219DC0] font-black">
            <MapPin className="w-5 h-5" /> Service area
          </div>
          <div className="mt-2 text-lg font-bold text-[#1C1C1C]">Lake Norman, NC</div>
          <p className="mt-2 text-sm text-[#1C1C1C]/60">Serving the Greater Lake Norman Region</p>
        </div>
      </section>
    </div>
  );
}
